import { render, staticRenderFns } from "./BaseInfoComponent.vue?vue&type=template&id=1be34cb0&scoped=true"
import script from "./BaseInfoComponent.vue?vue&type=script&lang=js"
export * from "./BaseInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoComponent.vue?vue&type=style&index=0&id=1be34cb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be34cb0",
  null
  
)

export default component.exports